// ─── Column titles ────────────────────────────────────────────────────────────

export const COL_TITLE = {
  FILE_NAME:   "File Name",
  UPLOADED_BY: "Uploaded By",
  UPLOAD_DATE: "Upload Date",
  FILE_SIZE:   "File Size",
};

// ─── Column data keys ─────────────────────────────────────────────────────────

export const COL_KEY = {
  FILE_NAME:   "filename",
  UPLOADED_BY: "uploaded_by",
  UPLOAD_DATE: "record_insert_time_stamp",
  FILE_SIZE:   "file_size",
  FILE_ID:     "file_id",
};

// ─── Column widths ────────────────────────────────────────────────────────────

export const COL_WIDTH = {
  UPLOADED_BY: 120,
  UPLOAD_DATE: 180,
  FILE_SIZE:   100,
  ACTION:      56,
};

// ─── File status values ───────────────────────────────────────────────────────

export const FILE_STATUS = {
  SUBMITTED: "submitted",
};

// ─── API response values ──────────────────────────────────────────────────────

export const UPLOAD_SUCCESS_STATUS = "success";

// ─── Error messages ───────────────────────────────────────────────────────────

export const ERROR_MSG = {
  NO_FILES:           "No files found.",
  FETCH_FILES:        "Failed to fetch employee proficiency files. Please try again.",
  SAFETY_CHECK:       "Could not run safety checks. Please retry.",
  FILE_NOT_FOUND:     "File content not found.",
  FETCH_CONTENT:      "Failed to fetch file content. Please try again.",
  SAVE_FILES:         "Failed to save files. Please try again.",
  SUBMIT_FILES:       "Failed to submit files. Please try again.",
};

// ─── Alert descriptions ───────────────────────────────────────────────────────

export const ALERT_MSG = {
  UPLOAD_SUCCESS: (name) => `File Uploaded: ${name}`,
  UPLOAD_FAIL:    (name) => `File upload failed: ${name}. Please try again.`,
  DELETE_SUCCESS: "File deleted successfully.",
  DELETE_FAIL:    "Failed to delete file. Please try again.",
};

// ─── Confirm dialogs ──────────────────────────────────────────────────────────

export const DELETE_CONFIRM = {
  title:      "Delete file?",
  content:    "It will no longer be used to infer your skills.",
  okText:     "OK",
  cancelText: "Cancel",
};

export const SUBMIT_CONFIRM = {
  title:      "Agree & Submit?",
  content:
    "By clicking Agree & Submit, you consent to SkillsBridge.AI using your skill proficiencies within your organization. " +
    "For details see Terms and Conditions. You cannot delete files after submission.",
  okText:     "Submit",
  cancelText: "Cancel",
};

// ─── Notifications ────────────────────────────────────────────────────────────

export const NOTIFICATION_DURATION  = 5;
export const NOTIFICATION_PLACEMENT = "topRight";

export const SAVE_NOTIFICATION = {
  MESSAGE:     "Changes saved!",
  DESCRIPTION: "You can review your re-inferred skills, then return here to make additional changes to your uploaded files if needed.",
};

export const SUBMIT_NOTIFICATION = {
  MESSAGE:     "Changes submitted!",
  DESCRIPTION: "Talent Mobility and Learning Catalyst recommendations will now reflect your re-inferred skills.",
};
